<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Species At Risk Report-->

<div class="container report-container">

  <div class="container"
    style="padding-top: 20px;">
    <div class="row"
      align="center">
      @if (currPage <= numPages) {
        <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
      }
      @if (currPage > numPages) {
        <h6 i18n>
        <small class="text-muted">
          Species At Risk Report
        </small>
      </h6>
      }
    </div>

    <div class="row" align="center">
      <div class="col" style="display: flex; justify-content: space-between;">
        <mat-icon></mat-icon>
        @if (currPage <= numPages) {
          <mat-spinner
            mode="determinate"
            [diameter]="50"
            [strokeWidth]="6"
          [value]="spinnerProgress"></mat-spinner>
        }

        @if (currPage > numPages && !isComplete) {
          <mat-icon
            style="color: #3ebfb9">
            check_circle_outline
          </mat-icon>
        }
        @if (!isComplete) {
          <button mat-mini-fab matTooltip="Delete Report" style="background-color: #005d87;" (click)="deleteReport()">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    </div>

  </div>

  <form [formGroup]="speciesAtRiskForm">

    <!-- When did the encounter occur -->
    @if (currPage === 1) {
      <div
        class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
          When did you encounter the species at risk?
        </h5>
        </div>
        <div class="row"
          align="center">
          <div class="col-2"></div>
          <div class="col-8">
            <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
              <mat-calendar [minDate]="sharedMethodsService.getMinDate(currTrip)" [maxDate]="maxDate" [(selected)]="encounterDate" (selectedChange)="dateTimeChange()"></mat-calendar>
            </mat-card>
            <div class="outer">
              <div class="inner-2">
                <h6 i18n class="blue-label">
                Time (24hr): &nbsp;
              </h6>
              </div>
              <div class="inner-2">
                <ngb-timepicker class="time-picker"
                  [spinners]="false"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="encounterTime"
                (ngModelChange)="dateTimeChange()"></ngb-timepicker>
              </div>
              @if (!encounterTime) {
                <mat-error i18n
                  style="margin-left: 15px;">
              Required
            </mat-error>
              }
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    }


    <!-- Location Coordinates -->
    @if (currPage === 2) {
      <div class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
          Where did you encounter the species at risk?
        </h5> 
        </div>
        <div style="display: flex; justify-content: space-between; align-items: baseline;">
          <h6 i18n class="blue-label">
            Latitude and Longitude
        </h6>
          <button mat-mini-fab type="button" class="fishing-button-blue" [matTooltip]="'Fill from GPS'" (click)="geolocationMethod.fillCoordinatesFromGps(speciesAtRiskForm.get('latitude')!, speciesAtRiskForm.get('longitude')!)">
            <mat-icon>pin_drop</mat-icon>
          </button>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label i18n>Latitude</mat-label>
            <input matInput formControlName="latitude" (mousedown)="geolocationMethod.openCoordinateDialog('latitude', speciesAtRiskForm.get('latitude')!)">
            @if (speciesAtRiskForm.get('latitude')?.hasError('object')) {
              <mat-error i18n>
            Required
          </mat-error>
            }
            @if (speciesAtRiskForm.get('latitude')?.hasError('latitude')) {
              <mat-error i18n>
            Latitude out of range. Must be no less than 38° 00.00'N and no greater than 72° 00.00'N
          </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label i18n>Longitude</mat-label>
            <input matInput formControlName="longitude" (mousedown)="geolocationMethod.openCoordinateDialog('longitude', speciesAtRiskForm.get('longitude')!)">
            @if (speciesAtRiskForm.get('longitude')?.hasError('object')) {
              <mat-error i18n>
            Required
          </mat-error>
            }
            @if (speciesAtRiskForm.get('longitude')?.hasError('longitude')) {
              <mat-error i18n>
            Longitude out of range. Must be no less than 40° 00.00'W and no greater than 148° 00.00'W
          </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    <!-- Species Info -->
    @if (currPage === 3) {
      <div
        class="container">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
          Species Info
        </h5>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
          Species
        </h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>
            Select
          </mat-label>
            <mat-select formControlName="species">
              @for (specie of speciesOptions; track specie) {
                <mat-option i18n
                  [value]="specie">
              {specie, select, Bass, Striped {Bass, Striped} Beluga {Beluga} Wolffish, Northern {Wolffish, Northern} Wolffish, Spotted {Wolffish, Spotted} Turtle, Loggerhead Sea {Turtle, Loggerhead Sea} Turtle, Leatherback Sea {Turtle, Leatherback Sea} Shark, White {Shark, White} Whale, Blue {Whale, Blue} Whale, North Atlantic Right {Whale, North Atlantic Right}}
            </mat-option>
              }
            </mat-select>
            @if (speciesAtRiskForm.invalid) {
              <mat-error i18n>
            Required
          </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
          Number of specimens
        </h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>
            Number
          </mat-label>
            <input matInput type="number" inputmode="numeric" formControlName="numSpecimens">
            @if (speciesAtRiskForm.get('numSpecimens')?.hasError('required')) {
              <mat-error i18n>
            Required
          </mat-error>
            }
            @if (speciesAtRiskForm.get('numSpecimens')?.hasError('max')) {
              <mat-error i18n>
            Value must be less than or equal to 9999
          </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
          Total estimated weight (optional)
        </h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>
            Weight
          </mat-label>
            <input matInput type="number" inputmode="numeric" formControlName="weight">
            @if (speciesAtRiskForm.get('weight')?.hasError('max')) {
              <mat-error i18n>
            Value must be less than or equal to 999999.999
          </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row">
          <h6 i18n class="blue-heading">
          Condition
        </h6>
          <mat-form-field appearance="outline">
            <mat-label i18n>
            Select
          </mat-label>
            <mat-select formControlName="condition">
              @for (condition of conditionOptions; track condition) {
                <mat-option i18n
                  [value]="condition">
              {condition, select, Alive {Alive} Dead {Dead} Most alive {Most alive} Most dead {Most dead}}
            </mat-option>
              }
            </mat-select>
            @if (speciesAtRiskForm.invalid) {
              <mat-error i18n>
            Required
          </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    <!-- Comments -->
    @if (currPage === 4) {
      <div
        class="container">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          Comments
        </h6>
          <mat-form-field appearance="fill">
            <mat-label i18n>
            Comments...
          </mat-label>
            <textarea matInput maxlength="2000" rows="9" formControlName="comments"></textarea>
          </mat-form-field>
        </div>
      </div>
    }

    <!-- Summary page -->

    @if (currPage > numPages) {
      <div
        class="container details">
        @if (!isComplete) {
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Is all information complete and ready to be saved?
        </h5>
          </div>
        }
        <div class="row">
          <h6 i18n class="blue-label">
          <b>
            Encounter Date:
          </b>
          {{ encounterDate | date }}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Latitude:</b>
          <span>
            {{speciesAtRiskForm.get('latitude')?.value}}
          </span>
          @if (speciesAtRiskForm.get('latitude')?.errors?.required) {
<small
                 class="red-label">
            [Required]
          </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Longitude:</b>
          <span>
            {{speciesAtRiskForm.get('longitude')?.value}}
          </span>
          @if (speciesAtRiskForm.get('longitude')?.errors?.required) {
<small
                 class="red-label">
            [Required]
          </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Species:</b>
          <span>
            {{speciesAtRiskForm.get('species')?.value}}
          </span>
          @if (speciesAtRiskForm.get('species')?.errors?.required) {
<small
                 class="red-label">
            [Required]
          </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Number of specimens:</b>
          <span>
            {{speciesAtRiskForm.get('numSpecimens')?.value}}
          </span>
          @if (speciesAtRiskForm.get('numSpecimens')?.errors?.required) {
<small
                 class="red-label">
            [Required]
          </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Total estimated weight:</b>
          <span>
            {{speciesAtRiskForm.get('weight')?.value}}
          </span>
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Condition:</b>
          <span>
            {{speciesAtRiskForm.get('condition')?.value}}
          </span>
          @if (speciesAtRiskForm.get('condition')?.errors?.required) {
<small
                 class="red-label">
            [Required]
          </small>
}
        </h6>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
          <b>Comments:</b>
          <span>
            {{speciesAtRiskForm.get('comments')?.value}}
          </span>
        </h6>
        </div>
      </div>
    }
  </form>


  <!-- Page navigation buttons -->
  @if (!isComplete) {
    <div class="row bottom-buttons">
      <div class="col-1"></div>
      <div class="col-4">
        <div class="row">
          <button mat-raised-button
            class="fishing-button-blue"
            type="button"
            (click)="toPreviousPage()">
            <span i18n>
            Back
          </span>
          </button>
        </div>
      </div>
      <div class="col-2"></div>
      <div class="col-4">
        <div class="row">
          <button mat-raised-button
            class="fishing-button-red"
            type="submit"
            (click)="toNextPage()">
            @if (currPage <= numPages) {
              <span i18n>
            Next
          </span>
            }
            @if (currPage > numPages) {
              <span i18n>
            Save
          </span>
            }
          </button>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  }
  @if (isComplete) {
    <div class="row bottom-buttons" style="display: flex; justify-content: center;">
      <div class="col-4">
        <div class="row" style="display: flex; justify-content: center;">
          <button mat-raised-button
            class="fishing-button-blue"
            type="button"
            (click)="toPreviousPage()">
            <span i18n>
            Back
          </span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
